import React, {useState} from 'react';

import {IconButton} from '@albert-io/atomic';
import QuestionTrackerModal from 'client/components/PracticeView/QuestionTrackerModal/QuestionTrackerModal.react';
import TrackedButton from 'client/components/Tracking/TrackedButton';
import withTracking from 'lib/hocs/withTracking';

const TrackedIconButton = withTracking(IconButton, {
  onClick: {content: () => 'My usage', event: 'click', type: 'button'}
});

interface Props {
  questionSetId: string;
  userId: string;
  /**
   * When true, render as a circular `info-circle` IconButton instead of the
   * "My usage" text button. Used by the fused FRQ grading footer.
   */
  asIconButton?: boolean;
}

export default function MoreInfo({questionSetId, userId, asIconButton = false}: Props) {
  const [showModal, setShowModal] = useState(false);

  function toggleModal() {
    setShowModal((value) => !value);
  }

  return (
    <>
      {asIconButton ? (
        <TrackedIconButton
          icon={['far', 'info-circle']}
          label='My usage'
          tooltip='My usage'
          onClick={toggleModal}
          data-testid='practice-view__usage-btn'
        />
      ) : (
        <TrackedButton type='button' onClick={toggleModal} data-testid='practice-view__usage-btn'>
          My usage
        </TrackedButton>
      )}
      {showModal && (
        <QuestionTrackerModal
          handleClose={() => {
            toggleModal();
          }}
          questionSetId={questionSetId}
          userId={userId}
        />
      )}
    </>
  );
}
